<div [ngClass]="{'mini': mini, 'search-page': isSearchPage}" class="smart-grid-{{ mode }}-container">
  <div class="left"></div>

  <div [ngClass]="{'full-page': fullPage}" class="header-container">
    <div class="navigation" matRipple mwoBackButton>
      <mat-icon>chevron_left</mat-icon>&nbsp;<ng-content select="[previousPage]"></ng-content>
    </div>
    <div *ngIf="hasSearch" class="search">
      <mwo-search-bar (onSearchInput)="handleSearch($event)"></mwo-search-bar>
    </div>
    <div class="header">
      <ng-content select="[header]"></ng-content>
    </div>
  </div>

  <div class="list-container" *ngIf="displayedItems?.length">
    <div #sliderRef class="keen-slider item-carousel-container" [ngStyle]="doneLoading === false ? {'visibility': 'hidden'} : {}">
      <ng-container *ngFor="let page of pages; let i = index">
        <div class="keen-slider__slide item-page-container">
          <div *ngFor="let item of displayedItems.slice(i * 4, i * 4 + 4); let j = index; let first = first; let last = last" class="item">
            <span [ngStyle]="item.placeholder === true ? {'visibility': 'hidden'} : {}">
              <ng-template *ngIf="item && !(isLoading$ | async)" [ngTemplateOutletContext]="{$implicit: item}" [ngTemplateOutlet]="itemTpl"></ng-template>
              <div *ngIf="last" class="spacer-bottom"></div>
            </span>
          </div>
        </div>
      </ng-container>
      <div *ngIf="(isLoading$ | async)">
        <mat-spinner></mat-spinner>
      </div>
    </div>
  </div>
  <div class="dots" [ngStyle]="dotHelper.length == 1 ? {visibility: 'hidden' } : {}">
    <button (click)="slider.moveToIdx(i)"
      *ngFor="let slide of dotHelper; let i = index"
      [class]="'dot ' + (i === currentSlide ? 'active' : '')"></button>
  </div>

  <div class="right"></div>
</div>
